import { Cohort } from '@litlingo/client';
import { downloadCohortContract } from 'actions/cohorts';
import LinkLookup from 'components/LinkLookup';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

type ComponentProps = {
  cohort: Cohort;
};

const CohortListItem: React.FC<ComponentProps> = ({ cohort }) => {
  const dispatch = useDispatch();

  const [isCreatingNew, setIsCreatingNew] = useState(false);

  const toggleIsCreatingNew = (): void => {
    setIsCreatingNew(!isCreatingNew);
  };

  const handleContractLinkClick = (): void => {
    dispatch(downloadCohortContract({ cohortId: cohort.uuid }));
  };

  const getDateRange = (): string => {
    if (!cohort.config.sync_start_date) {
      return 'Not set';
    }

    return `${moment(cohort.config.sync_start_date).format('MM/DD/YYYY')} - 
                ${
                  cohort.config.sync_end_date
                    ? moment(cohort.config.sync_end_date).format('MM/DD/YYYY')
                    : 'Present'
                }`;
  };

  const getDateRangeType = (): string => {
    if (!cohort.config.sync_start_date) {
      return '';
    }

    return `${
      cohort.config.sync_end_date
        ? `${moment(cohort.config.sync_end_date).from(
            moment(cohort.config.sync_start_date),
            true
          )} `
        : 'Livestream'
    }`;
  };

  return (
    <>
      <tr className="row-hover table-row border-t border-gray-200 align-middle hover:bg-litlingo-gray-0">
        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <div className="pl-4">
              <span>{cohort.name}</span>
            </div>
          </div>
        </td>
        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <div className="py-2 flex flex-col gap-1">
              <div>{getDateRange()}</div>
              <div>{getDateRangeType()}</div>
            </div>
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {cohort.config.insight_seats}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {cohort.config.prevent_seats}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {cohort.config.users_list_filenames[0] && (
              <>
                <span className="max-w-32 truncate">
                  {cohort.config.users_list_filenames[0]?.split('.')[0]}
                </span>
                <span className="">.{cohort.config.users_list_filenames[0]?.split('.').pop()}</span>
              </>
            )}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {cohort.config.contract_filename && (
              <button
                type="button"
                className="flex flex-row focus:outline-none"
                onClick={handleContractLinkClick}
              >
                <span className="max-w-32 truncate underline">
                  {cohort.config.contract_filename?.split('.')[0]}
                </span>
                <span className="underline">
                  .{cohort.config.contract_filename?.split('.').pop()}
                </span>
              </button>
            )}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            <div className="text-left text-body clamped-text-2 overflow-hidden">
              {cohort.config.notes}
            </div>
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 pl-4 flex text-body items-center">
            <LinkLookup
              routeName="customer-cohort"
              routeParams={{ cohortId: cohort.uuid }}
              onClick={toggleIsCreatingNew}
              className="row-hover-conditional hidden text-litlingo-primary underline focus:outline-none"
            >
              View
            </LinkLookup>
          </div>
        </td>
      </tr>
    </>
  );
};

export default CohortListItem;
